import {Component, Inject, OnInit} from '@angular/core';
import {UtilsService} from "../../shared/utils.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {AssetsViewContractorsFilters} from "./assets-view-contractors-filter.interface";

@Component({
  selector: 'app-assets-view-contractors-filter',
  templateUrl: './assets-view-contractors-filter.component.html',
  styleUrls: ['./assets-view-contractors-filter.component.scss']
})
export class AssetsViewContractorsFilterComponent implements OnInit {

  filters: AssetsViewContractorsFilters = {
    industry: '',
    industries: []
  } as AssetsViewContractorsFilters;

  constructor(
    public utils: UtilsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<AssetsViewContractorsFilterComponent>
  ) { }

  ngOnInit() {
    this.getIndustries();

    this.filters.industry = this.data['industry'];
  }

  /**
   * Retrieves list of industries asynchronously and sets it in filters object.
   *
   * @return {Promise<void>} A Promise that resolves once industries are obtained and set.
   */
  private async getIndustries() {
    this.filters.industries = await this.utils.getIndustries();
  }

  /**
   * Clears the filters and closes the form.
   *
   * @return {void}
   */
  onClearAndClose(): void {
    // Clear the filters.
    this.filters.industry = '';

    this.onSaveAndClose();
  }

  /**
   * Saves the filters and closes the dialog.
   *
   * @return {void}
   */
  onSaveAndClose(): void {
    let response: any;

    response = {
      industry: this.filters.industry
    }

    this.dialogRef.close(response);
  }

  /**
   * Closes the dialog.
   *
   * @return {void}
   */
  onClose(): void {
    this.dialogRef.close();
  }
}
